(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaStatusDialogController', CampagnaStatusDialogController);

    CampagnaStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CampagnaStatus'];

    function CampagnaStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CampagnaStatus) {
        var vm = this;

        vm.campagnaStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campagnaStatus.id !== null) {
                CampagnaStatus.update(vm.campagnaStatus, onSaveSuccess, onSaveError);
            } else {
                CampagnaStatus.save(vm.campagnaStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:campagnaStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
